<template>
  <label
    class="ds-radio"
    :class="{ 'ds-radio--disabled': this.isDisabled }"
  >
    <input
      class="ds-radio-input"
      type="radio"
      :name="name"
      :value="val"
      :checked="val === modelValue"
      :aria-invalid="hasErrors && !modelValue"
      :disabled="isDisabled"
      @change="$emit('update:modelValue', val)"
    >
    <div class="ds-radio-indicator" />
    <span class="ds-radio-text">
      <slot />
      <span v-if="!hasSlot">
        {{ label || val }}
      </span>
    </span>
  </label>
</template>

<script>
import validation from './validation-mixin';

export default {
  name: 'RadioField',
  emits: ['update:modelValue'],
  mixins: [validation],
  props: {
    modelValue: {
      type: [String, Number, Boolean],
    },
    val: {
      type: [String, Number, Boolean],
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
    label: {
      type: String,
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    hasSlot() {
      return this.$slots.default;
    },
  },
};
</script>
